/**
 * @fileoverview Dialog to copy a portfolio and all of its properties
 * @author Housefolios
 * @created 2021-09-16 13:21:50
 * @modified 2025-05-08 16:53:38
 * @ Modified by: David Helmick
 * @ Modified time: 2025-08-18 14:52:48
 * @ Modified by: AI Assistant
 * @ Modified time: 2025-01-27
 * @ Description: Now using the generic duplicate entity system
 */

import React from 'react'
import PropTypes from 'prop-types'
import { DuplicatePortfolio as GenericDuplicatePortfolio } from '@/housefolios-components/shared/DuplicateEntity'
import withSession from '@/housefolios-components/Session/withSession'
import { useQuery } from '@apollo/client/react'
import { GET_PORTFOLIOS } from '../queries'
import { LoadingSkeleton } from '@/housefolios-components/LoadingSkeleton'

/**
 * DuplicatePortfolio Component
 *
 * This component is now a thin wrapper around the generic duplicate entity system.
 * It maintains backward compatibility while leveraging the new centralized system.
 *
 * @param {Object} props - Component props
 * @param {Object} props.portfolio - The portfolio object to duplicate
 * @param {Array} props.portfolios - Available portfolios
 * @param {string} props.selectedPortfolio - Currently selected portfolio
 * @param {Function} props.setSelected - Function to clear selection after duplication
 * @param {boolean} props.sidebarMenu - Whether to show in sidebar menu
 * @param {Object} props.session - User session object
 */
function DuplicatePortfolioComponent(props) {
  // Extract the specific props we need for the generic component
  const {
    portfolio,
    // portfolios,
    selectedPortfolio,
    setSelected,
    sidebarMenu,
    session,
    ...otherProps
  } = props

  const { loading, data, error } = useQuery(GET_PORTFOLIOS)
  if (loading) return <LoadingSkeleton variant="menuItem" />
  if (error) return `Error! ${error.message}`
  const { portfolios = [] } = data

  // Pass through all props to the generic component
  return (
    <GenericDuplicatePortfolio
      portfolioId={portfolio._id}
      portfolio={portfolio}
      portfolios={portfolios}
      selectedPortfolio={selectedPortfolio}
      setSelected={setSelected}
      session={session}
      sidebarMenu={sidebarMenu}
      {...otherProps}
    />
  )
}

// PropTypes
DuplicatePortfolioComponent.propTypes = {
  portfolio: PropTypes.object.isRequired,
  portfolios: PropTypes.array.isRequired,
  selectedPortfolio: PropTypes.string,
  setSelected: PropTypes.func,
  sidebarMenu: PropTypes.bool,
  session: PropTypes.object.isRequired,
}

export default withSession(DuplicatePortfolioComponent)
